<ion-item lines="none" class="ion-no-padding">
  <ion-label *ngIf="!hideLabel" position="stacked">{{ label + (required ? '*' : '')  }}</ion-label>
  <ion-input type="email" [id]="id" [placeholder]="placeholder" [(ngModel)]="value" [debounce]="debounce"
  [disabled]="disabled" (ionBlur)="checkValidity()" [inputFocus]="focus"></ion-input>
</ion-item>